const GTM_TRACKERS = {
  HOME: {
    AJAK_TEMAN: 'bprgtm_main_home_referral_ajak_teman',
    UNDUH_APLIKASI: 'cntgtm_main_depositobpr_unduh_aplikasi',
    GOOGLE_PLAY: 'cntgtm_main_depositobpr_google_play',
    APP_STORE: 'cntgtm_main_depositobpr_app_store',
  },
  BLOG: {
    MAIN: 'bprgtm_main_blog',
    DEPOSITO_SEKARANG: 'bprgtm_main_blog_cta_deposito_sekarang',
  },
  REFERRAL: {
    DAFTAR_SEKARANG: 'bprgtm_main_referral_daftar_sekarang',
    SUBMIT_REGISTER: 'bprgtm_main_referral_register',
    PELAJARI_LEBIH_LANJUT: 'bprgtm_referral_pelajari_lebih_lanjut',
    DOWNLOAD_PANDUAN_PROGRAM: 'bprgtm_referral_download_panduan_program',
  },
  PELUANG: {
    MAIN: 'bprgtm_main_peluang_deposito',
    AJUKAN_DEPOSITO: 'bprgtm_main_peluang_deposito_ajukan_sekarang',
  },
  PROMO: {
    MAIN: 'bprgtm_main_promo',
    KLIK_DISINI: 'bprgtm_main_promo_klik_disini',
    YUK_DEPOSITO_SEKARANG: 'bprgtm_main_promo_yuk_deposito',
    MAU_PROMONYA: 'bprgtm_main_promo_mau_promo',
  },
  KALKULATOR: {
    MAIN: 'bprgtm_main_kalkulator',
    HITUNG: 'bprgtm_kalkulator_hitung',
    RESET: 'bprgtm_kalkulator_reset',
  },
  FAQ: {
    MAIN: 'bprgtm_main_faq',
    UMUM: 'bprgtm_faq_umum',
    KEAMANAN_DANA: 'bprgtm_faq_keamanan_dana',
    INFORMASI_PRIBADI: 'bprgtm_faq_informasi_pribadi',
    PROSES_TRANSAKSI: 'bprgtm_faq_proses_transaksi',
    ADVIS: 'bprgtm_faq_advis',
    BILYET: 'bprgtm_faq_bilyet',
    JANGKA_WAKTU: 'bprgtm_faq_jangka_waktu',
    BPRS: 'bprgtm_faq_bprs',
  },
  PILIH_YANG_TEPAT: {
    MILLENIAL_PROFESSIONAL: {
      DOWNLOAD: 'bprgtm_landing_millen_download',
      WHATSAPP: 'bprgtm_landing_millen_wa',
      TELEGRAM: 'bprgtm_landing_millen_telegram',
    },
    ACTIVE_WOMAN: {
      DOWNLOAD: 'bprgtm_landing_active_woman_download',
      WHATSAPP: 'bprgtm_landing_active_woman_wa',
      TELEGRAM: 'bprgtm_landing_active_woman_telegram',
    },
    YOUNG_ENTREPRENEUR: {
      DOWNLOAD: 'bprgtm_landing_entrepreneur_download',
      WHATSAPP: 'bprgtm_landing_entrepreneur_wa',
      TELEGRAM: 'bprgtm_landing_entrepreneur_telegram',
    },
  },
};

export default GTM_TRACKERS;
